import { useState } from 'react';
import type React from 'react';

import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import { translate } from '@repo/phrase';

import AssetQuestionnaireModalContent from './asset-questionnaire-modal-content.component';

interface Props {
    readonly visible: boolean;
    readonly onClose: () => void;
}

export const AssetQuestionnaireModal = ({ visible, onClose }: Props) => {
    const [footer, setFooter] = useState<React.ReactElement | null>(null);

    if (!visible) {
        return null;
    }

    return (
        <Modal visible={visible} handleCloseBtn={onClose}>
            <Sheets
                aria-label={translate('questionnaire_modal_title')}
                header={<ModalHeader title={translate('questionnaire_modal_title')} />}
                footer={footer}
            >
                <ModalBody>
                    <AssetQuestionnaireModalContent setFooter={setFooter} />
                </ModalBody>
            </Sheets>
        </Modal>
    );
};
